import { Routes, Route } from "react-router-dom";
import Login from "../Screens/Login/Index";
import UniversityWebDetails from "../Screens/UniversityWebDetails/Index";
import University from "../Screens/University/Index";
import Dashboard from "../Screens/Dashboard/Dashboard";
import PrivateRoute from "./PrivateRoute";
import Setting from "../Screens/Setting/Index";
import Campus from "../Screens/Campus/Index";
import Courses from "../Screens/Courses/Index";
import PageNotFound from "../Screens/PageNotFound";
import UniversityImageUpload from "../Screens/UniversityImageUpload/Index";
import Contact from "../Screens/Contact/Index";

export default function NavigationRoute() {
  return (
    <Routes>
      <Route path="/" element={<PrivateRoute> {<Dashboard />}</PrivateRoute>} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/university_website_details"
        element={<PrivateRoute>{<UniversityWebDetails />} </PrivateRoute>}
      />
      <Route
        path="/university"
        element={<PrivateRoute>{<University />} </PrivateRoute>}
      />
      <Route
        path="/contacts"
        element={<PrivateRoute>{<Contact />} </PrivateRoute>}
      />
      <Route
        path="/campus"
        element={<PrivateRoute>{<Campus />} </PrivateRoute>}
      />
      <Route
        path="/courses"
        element={<PrivateRoute>{<Courses />} </PrivateRoute>}
      />
      <Route
        path="/setting"
        element={<PrivateRoute>{<Setting />} </PrivateRoute>}
      />
      <Route
        path="/university_image_upload"
        element={<PrivateRoute>{<UniversityImageUpload />} </PrivateRoute>}
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}
